import React, { FC } from 'react';
import { useFormatters } from '../../../../../../../../../../core/hooks/useFormatters';
import { BookingDTO } from '../../../../../../../../../../types';
import { isCourse } from '../../../../../../../../../../utils/bookInfo';
import Text, { TextType } from '../../../../../../../../Components/Text';
import { BookingBodyContentDurationDataHooks } from '../../../../../../../datahooks';

export interface BookingBodyContentDurationProps {
  booking: BookingDTO;
}

const BookingBodyContentDuration: FC<BookingBodyContentDurationProps> = ({
  booking,
}) => {
  const { getDuration } = useFormatters();
  const durationName = booking.dynamicPriceInfo?.durationName;

  if (isCourse(booking)) {
    return null;
  }

  let durationText = getDuration(
    new Date(booking.start),
    new Date(booking.end),
  );

  if (durationName) {
    durationText += ` (${durationName})`;
  }

  return (
    <div data-hook={BookingBodyContentDurationDataHooks.Main}>
      <Text
        data-hook={BookingBodyContentDurationDataHooks.Text}
        type={TextType.Secondary}
      >
        {durationText}
      </Text>
    </div>
  );
};

export default BookingBodyContentDuration;
